export enum PaymentIntentCaptureMethod {
    Automatic = "automatic",
    AutomaticAsync = "automatic_async",
    Manual = "manual",
}
